import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Header = ({ authToken, handleLogout, onToggleDarkMode, darkMode, cart }) => {
  const navigate = useNavigate();

  const handleLogoutClick = () => {
    handleLogout();
    navigate('/'); // Navigate to home page after logout
  };

  const [navActive, setNavActive] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [searchScope, setSearchScope] = useState('all');

  const handleHamburgerClick = () => {
    setNavActive(!navActive);
  };

  return (
    <div className="header">
      <Link to="/">
        <img src="/assets/graphics/logos/Logo_PNG_RGB.png" alt="Sabrenetics logo" className="logo" />
      </Link>
      <div className="hamburger" onClick={handleHamburgerClick}>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <ul className={`nav-links${navActive ? ' active' : ''}`}>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/books">Books</Link></li>
        <li><Link to="/cyberwareCatalogue">Cyberware Catalogue</Link></li>
        <li><Link to="/cyborgmuseum">Cyborg Museum</Link></li>
        <li><Link to="/cytheseus">Cytheseus</Link></li>
        <li><Link to="/crispr">CRISPR</Link></li>
        <li><Link to="/donate">Donate</Link></li>
        <li><Link to="/events">Events</Link></li>
        <li><Link to="/history">History</Link></li>
        <li><Link to="/library">Library</Link></li>
        <li><Link to="/merchandise">Merchandise</Link></li>
        <li><Link to="/nootropics">Nootropics</Link></li>
        <li><Link to="/transhumanrights">Transhuman Rights</Link></li>
        <li><Link to="/volunteer">Volunteer</Link></li>
        <li><Link to="/contactus">Contact us</Link></li>
        {!authToken ? (
          <>
            <li><Link to="/login">Login</Link></li>
            <li><Link to="/signup">Sign up</Link></li>
          </>
        ) : (
          <>
            <li><Link to="/account">Account</Link></li>
            <li><Link to="/logout" onClick={handleLogoutClick}>Logout</Link></li>
          </>
        )}
        {/* Removed cart from nav-links; cart now in header-right */}
      </ul>
      {/* Right-side controls: cart, search and dark mode */}
      <div className="header-right">
        {/* Cart icon and count */}
        <Link to="/cart" className="cart-link">🛒 Cart ({cart ? cart.length : 0})</Link>
        <form
          className="search-form"
          onSubmit={e => {
            e.preventDefault();
            navigate(`/search?scope=${encodeURIComponent(searchScope)}&q=${encodeURIComponent(searchText)}`);
          }}
        >
          <select
            className="search-scope"
            value={searchScope}
            onChange={e => setSearchScope(e.target.value)}
          >
            <option value="all">All</option>
            <option value="shop">Shop</option>
            <option value="page">Pages</option>
          </select>
          <input
            type="text"
            placeholder="Search..."
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
            className="search-input"
          />
          <button type="submit" className="search-button">🔍</button>
        </form>
        <button className="dark-toggle" onClick={onToggleDarkMode}>
          {darkMode ? '🌙' : '☀️'}
        </button>
      </div>
    </div>
  );
}

export default Header;
